import React from 'react';

import { Field, FormSection } from 'redux-form';

import Header from 'components/shared/Header';
import * as validator from 'helpers/Validator';

import { TextField, RadioButtonGroup } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';

class SchoolDetails extends React.Component {
  render() {
    return (
      <FormSection name="school">
        <div id="top" style={{ marginTop: '25px' }}>
          <Header name="Current School" />
          <div className="row" style={{ marginBottom: '70px' }}>
            <div className="row">
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="university"
                  type="text"
                  component={TextField}
                  floatingLabelText="University/College"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="field_of_study"
                  type="text"
                  component={TextField}
                  floatingLabelText="Field of Study"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="university_city"
                  type="text"
                  component={TextField}
                  floatingLabelText="City"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="university_country"
                  type="text"
                  component={TextField}
                  floatingLabelText="Country"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                />
              </div>
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
              <h5
                style={{
                  textAlign: 'center',
                  marginBottom: '20px',
                  fontSize: '18px',
                }}
              >
                Graduation Year
              </h5>
              <Field
                name="graduating_year"
                component={RadioButtonGroup}
                style={{
                  maxWidth: '500px',
                  margin: 'auto',
                  textAlign: 'center',
                }}
                validate={[validator.required]}
              >
                <RadioButton
                  value={`${new Date().getFullYear()}`}
                  label={`${new Date().getFullYear()}`}
                  style={{ width: '102px', display: 'inline-flex' }}
                />
                <RadioButton
                  value={`${new Date().getFullYear() + 1}`}
                  label={`${new Date().getFullYear() + 1}`}
                  style={{ width: '102px', display: 'inline-flex' }}
                />
                <RadioButton
                  value={`${new Date().getFullYear() + 2}`}
                  label={`${new Date().getFullYear() + 2}`}
                  style={{ width: '102px', display: 'inline-flex' }}
                />
                <RadioButton
                  value={`${new Date().getFullYear() + 3}`}
                  label={`${new Date().getFullYear() + 3}`}
                  style={{ width: '102px', display: 'inline-flex' }}
                />
                <RadioButton
                  value={`${new Date().getFullYear() + 4}+`}
                  label={`${new Date().getFullYear() + 4}+`}
                  style={{ width: '86px', display: 'inline-flex' }}
                />
              </Field>
            </div>
          </div>
        </div>
      </FormSection>
    );
  }
}

export default SchoolDetails;
